import {useAutocomplete} from "@/autocomplete/context/GlobalContext";
import {Modal} from "@/autocomplete/components/Modal";
import {Form} from "@/autocomplete/components/Form";
import {Categories} from "@/autocomplete/components/Categories";
import {Products} from "@/autocomplete/components/Products";
import {useEffect} from "react";
import {initializeHeaderSearchIntegration} from "@/autocomplete/utils/headerSearchIntegration";

export function AppAutocomplete() {
    const {autocomplete, searchRef, panelRef} = useAutocomplete();

    useEffect(() => {
        initializeHeaderSearchIntegration();
    }, []);

    return (
        <div className={`algoliaAutocomplete`} {...autocomplete.getRootProps({})}>
            <header className={"algoliaAutocomplete__header"}>
                <Form />
            </header>
            <Modal>
                <div className="algoliaAutocomplete__wrapper">
                    <div className={"algoliaAutocomplete__layout"}>
                        <section className="algoliaAutocomplete__content"
                                 ref={panelRef} {...autocomplete.getPanelProps({})}>
                            <aside className="algoliaAutocomplete__side">
                                <Categories/>
                            </aside>
                            <div className="algoliaAutocomplete__results" ref={searchRef}>
                                <Products/>
                            </div>
                        </section>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

